module.exports = __webpack_public_path__ + "static/media/add_business.00fc9ee2.svg";